/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
// import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { useLocation } from "react-router-dom";
import DropDownSelect from "../../../../components/common/Dropdown";
import User from "../../../../services/api/user";
import Button from "../../../../components/common/Button";
import Member from "../../../../services/api/member";
import useQueryParams from "../../../../hooks/useQueryParams";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import Loader from "../../../../components/common/Loader/Loader";

function BulkTransferSearch({ fetchSearchData, setOpen }) {
  const [roleValue, setRoleValue] = useState("");
  const [role, setRole] = useState([]);
  const location = useLocation();
  const { getQueryObject, getQueryParams } = useQueryParams();
  const toast = useContext(ToastAlertContext);
  const [isLoading, setIsLoading] = useState(false);

  const getRoles = async () => {
    const [rolesRes] = await Promise.all([User.getRole()]);

    const rolePos =
      rolesRes?.data?.map((d) => ({
        entityTitle: d.name,
        value: d.name,
      })) ?? [];

    setRole(rolePos);
    // dispatch({ type: SET_ROLES, payload: rolePos });
  };

  const queryObject = getQueryObject();
  const [query, params] = getQueryParams(queryObject);

  const handleAssign = async () => {
    const queryParams = new URLSearchParams(location.search);
    const roleIdsQueryParam = queryParams.get("roleIds");
    const roleIds = roleIdsQueryParam
      ? roleIdsQueryParam
          ?.split(",")
          ?.map((id) => parseInt(id, 10))
          ?.filter(Boolean)
      : [];
    try {
      setIsLoading(true);
      const data = {
        rolesToBeAssigned: [roleValue],
        roleIds,
        bulkAction: "ASSIGN",
        rolesToBeDeleted: [],
        areaId: queryParams.get("areaId") || null,
        zoneId: queryParams.get("zoneId") || null,
        regionId: queryParams.get("regionId") || null,
        chapterId: queryParams.get("chapterId") || null,
        districtId: queryParams.get("districtId") || null,
        blockId: queryParams.get("blockId") || null,
        proxyRoles: {
          districtIds: null,
        },
      };
      const response = await Member.bulkRoleAuthorization({ data });
      if (response.code === 200) {
        toast.show("Member Assign Roles Successfully", AlertStatus.SUCCESS);
        fetchSearchData(query, params);
        setOpen(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      toast.show(error, AlertStatus.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRevoke = async () => {
    const queryParams = new URLSearchParams(location.search);
    const roleIdsQueryParam = queryParams.get("roleIds");
    const roleIds = roleIdsQueryParam
      ? roleIdsQueryParam
          ?.split(",")
          ?.map((id) => parseInt(id, 10))
          ?.filter(Boolean)
      : [];
    try {
      setIsLoading(true);
      const data = {
        rolesToBeAssigned: [],
        roleIds,
        bulkAction: "REVOKE",
        rolesToBeDeleted: [roleValue],
        areaId: queryParams.get("areaId") || null,
        zoneId: queryParams.get("zoneId") || null,
        regionId: queryParams.get("regionId") || null,
        chapterId: queryParams.get("chapterId") || null,
        districtId: queryParams.get("districtId") || null,
        blockId: queryParams.get("blockId") || null,
        proxyRoles: {
          districtIds: null,
        },
      };
      const response = await Member.bulkRoleAuthorization({ data });
      if (response.code === 200) {
        toast.show("Member Revoke Roles Successfully", AlertStatus.SUCCESS);
        fetchSearchData(query, params);
        setOpen(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      // console.log("Something went wrong. Please contact support.");
      toast.show(error, AlertStatus.ERROR);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getRoles();
  }, []);
  return (
    <Box>
      <DropDownSelect
        title="Roles"
        name="roleIds"
        selectOptions={role}
        value={roleValue}
        setValue={setRoleValue}
        style={{ maxWidth: 290 }}
      />
      <Box sx={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        <Button
          label="Assign"
          style={{ backgroundColor: "green" }}
          onClick={handleAssign}
        />
        <Button
          label="Revoke"
          style={{ backgroundColor: "red" }}
          onClick={handleRevoke}
        />
      </Box>
      {isLoading && <Loader />}
    </Box>
  );
}

export default BulkTransferSearch;
